/**
 * Acceso del Inicio de RH al listado de solicitudes cerradas (SRH-340).
 *
 * Las barras Cubierta y Rechazada de «Solicitudes por estatus» llevan al
 * listado de solicitudes con ese estatus ya filtrado. El listado lee el
 * filtro de la URL, así que el vínculo se puede compartir y sobrevive a
 * recargar.
 */

/** Los estatus del Inicio que llevan a un listado. El resto de las barras no. */
export const ESTATUS_CON_LISTADO = ['cubierta', 'rechazada'] as const

export type EstatusConListado = (typeof ESTATUS_CON_LISTADO)[number]

export const tieneListado = (estatus: string): estatus is EstatusConListado =>
  (ESTATUS_CON_LISTADO as readonly string[]).includes(estatus)

/** El listado de solicitudes con el estatus ya filtrado, o null si ese estatus no lleva a uno. */
export const rutaDeSolicitudesPorEstatus = (estatus: string): string | null =>
  tieneListado(estatus) ? `/job-requests?status=${estatus}` : null

/**
 * El filtro que viene en la URL, validado contra los que el listado conoce.
 * Un valor inventado o vacío no filtra nada: vuelve a «todos» en vez de dejar
 * la pantalla vacía.
 */
export const estatusDeLaUrl = (
  valor: string | null | undefined,
  validos: readonly string[],
): string => (valor && validos.includes(valor) ? valor : 'all')
